import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const SHARE_HOUSE_SOURCES_A = [
  {
    sourceId: "share-house-source-sharing",
    topicId: "share-house",
    title: "Sharing a residential rental property",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/sharing-a-residential-rental-property",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 co-tenant, transfer, subletting과 additional occupant의 구분, landlord written consent, shared bond 변경 절차를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW residential tenancy 안에서 집을 공유하는 주요 법적 구조와 변경 절차",
    followUp: "입주·퇴거 전에 현재 tenancy agreement, landlord consent와 최신 shared-tenancy form 재확인",
  },
  {
    sourceId: "share-house-source-agreement",
    topicId: "share-house",
    title: "Standard residential tenancy agreement",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rental-forms-surveys-and-data/resources/standard-residential-tenancy-agreement",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Fair Trading 공식 standard agreement에서 tenancy parties, standard terms, attachments와 tenant copy 제공 의무를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW residential tenancy agreement의 서면 기록과 당사자 확인",
    followUp: "계약서 이름, fixed/periodic term, special terms와 서명된 최신 사본 확인",
  },
  {
    sourceId: "share-house-source-condition",
    topicId: "share-house",
    title: "Rental property condition reports",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/rental-property-condition-reports",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 condition report와 timestamped photos의 증거 역할, 새 co-tenant·occupant 합류 시 새 report가 자동 생성되지 않는 점을 확인",
    reviewStatus: "live_verified",
    claimScope: "입주·퇴거 상태와 damage·bond 분쟁 증거 보존",
    followUp: "본인이 합류·퇴거하는 날짜의 방·공용공간 사진과 기존 condition report 접근권 확인",
  },
  {
    sourceId: "share-house-source-rbo",
    topicId: "share-house",
    title: "Rental Bonds Online for tenants",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/residential-rental-bonds/rental-bonds-online-for-tenants",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 RBO 본문에서 bond lodgement, notification, viewing and claim 기능과 최대 residential bond 일반 기준을 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW residential bond의 공식 보관·조회·환급 시스템",
    followUp: "principal tenant, bond number, 실제 lodgement confirmation과 본인 연락처 등록 확인",
  },
  {
    sourceId: "share-house-source-bond-refund",
    topicId: "share-house",
    title: "Getting your bond back at the end of a tenancy",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/renting-a-place-to-live/getting-your-bond-back",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 co-tenant bond share 요청, remaining tenants의 14-day repayment 일반 규칙과 예외, principal tenant claim 역할을 확인",
    reviewStatus: "live_verified",
    claimScope: "공동 tenancy에서 나가는 co-tenant의 bond share와 tenancy 종료 후 refund",
    followUp: "본인 debt·damage 주장, final AVO 예외와 shared tenancy form 상태를 퇴거 시점에 재확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of SHARE_HOUSE_SOURCES_A) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
